(function () {

    function injectGoKwikStyles() {
        const host = document.querySelector("shadow-dom-container");

        if (!host || !host.shadowRoot) return;

        // Prevent duplicate injection
        if (host.shadowRoot.getElementById("cc-gokwik-style")) return;

        const style = document.createElement("style");
        style.id = "cc-gokwik-style";

        style.textContent = `
            /* + Add Button */
            .add-btn{
                border:1.5px solid #ED1B24 !important;
                color:#ED1B24 !important;
                background:#FFFFFF !important;
                border-radius:8px !important;
                font-weight:500 !important;
                transition:all .25s ease;
            }

            .add-btn:hover{
                background:#ED1B24 !important;
                color:#FFFFFF !important;
            }

            /* Progress Text */
            .next-milestone-text{
                color:#16A34A !important;
                font-weight:600 !important;
            }
        `;

        host.shadowRoot.appendChild(style);
    }

    // Watch until GoKwik loads
    const observer = new MutationObserver(() => {
        injectGoKwikStyles();
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    // Initial attempt
    injectGoKwikStyles();

})();